import Vue from 'vue'
import Router from 'vue-router'

//组件模块
import Home from './pages/Home.vue'
import About from './pages/About.vue'
import Demo from './pages/Demo.vue'
import DemoDetails from './pages/DemoDetails.vue'
import Product from './pages/Product.vue'

import News from './pages/News.vue'
import Videos from './pages/Videos.vue'
import Downloads from './pages/Downloads.vue'

import NewsDetails from './pages/NewsDetails.vue'
import VideoPlay from './pages/VideoPlay.vue'





Vue.use(Router)

export default new Router({
    routes: [
        { path: "/", redirect: "/home" },
        { path: "/home", component: Home },
        { path: "/about", component: About },
        { path: "/demo", component: Demo },
        { path: "/demodetails", component: DemoDetails },
        { path: "/product", component: Product,props: route => ({ query: route.query }) },
        
        { path: "/news", component: News },
        { path: "/videos", component: Videos },
        { path: "/downloads", component: Downloads },
        
        { path: "/newsdetails", component: NewsDetails },
        { path: "/videoplay", component: VideoPlay },
    ]
})
